export default __webpack_public_path__ + "static/media/Inklink Video.2ddf73fd.mp4";